<template>
  <v-main>
    <navigation v-if="!liffUser"/>

    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"/>
    </v-overlay>

    <v-card flat max-width="1185" class="mx-auto">
      <guide-tour config-key="superLink">
        <div>
          連結設定可幫助您快速追蹤患者加入的流量來源與轉換成效
          <router-link to="/analytics" class="link_blue--text" style="text-decoration: none;">
            <span style="text-decoration: none;">（統計數據請點我）</span>
          </router-link>
          ，進而優化行銷策略，提高患者轉換率。
        </div>
      </guide-tour>

      <v-container fluid>
        <v-row>
          <v-col cols="12" sm="6">
            <v-card flat class="mx-auto" outlined>
              <v-tabs v-model="tabs">
                <v-tab @click="setMode('')">加入 LINE 官方帳號</v-tab>
                <v-tab v-show="jsonState['add_messenger']" @click="setMode('add_messenger')">加入 Facebook Messenger</v-tab>
                <v-tab v-show="jsonState['appointment']" @click="setMode('appointment')">線上預約連結</v-tab>
              </v-tabs>

              <v-tabs-items v-model="tabs" touchless>
                <v-tab-item>
                  <v-container class="px-6 py-6">
                    <div class="relative mt-4">
                      <v-icon color="primary" size="14" class="mdi mdi-circle mb-1"></v-icon>
                      <span>選擇模式（必選2選1）</span>
                      <v-tooltip top max-width="500">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon color="grey lighten-1" v-bind="attrs" v-on="on">mdi-help-circle-outline</v-icon>
                        </template>
                        <span v-text="''"/>
                      </v-tooltip>
                    </div>
                    <div class="relative ml-4">
                      <v-select
                        return-object filled dense rounded full-width
                        item-text="mode"
                        hide-details="auto"
                        class="setting-input mt-4"
                        label="選擇模式"
                        :items="Object.keys(jsonMode)"
                        v-model="mode"
                      ></v-select>
                    </div>
                    <div class="relative mt-4">
                      <v-icon color="primary" size="14" class="mdi mdi-circle mb-1"></v-icon>
                      <span>選擇來源</span>
                      <v-tooltip top max-width="500">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon color="grey lighten-1" v-bind="attrs" v-on="on">mdi-help-circle-outline</v-icon>
                        </template>
                        <span v-text="''"/>
                      </v-tooltip>
                    </div>
                    <div class="relative ml-4">
                      <v-select
                        return-object filled dense rounded full-width
                        item-text="source"
                        hide-details="auto"
                        class="setting-input mt-4"
                        label="選擇來源"
                        :items="Object.keys(jsonSource[mode])"
                        v-model="source"
                      ></v-select>
                    </div>
                  </v-container>
                </v-tab-item>

                <v-tab-item v-show="jsonState['add_messenger']">
                  <v-container class="px-6 py-6">
                    <div class="relative mt-4">
                      <v-icon color="primary" size="14" class="mdi mdi-circle mb-1"></v-icon>
                      <span>選擇來源</span>
                    </div>
                    <div class="relative ml-4">
                      <v-select
                        return-object filled dense rounded full-width
                        item-text="source"
                        hide-details="auto"
                        class="setting-input mt-4"
                        label="選擇來源"
                        :items="Object.keys(jsonSource[mode])"
                        v-model="source"
                      ></v-select>
                    </div>
                  </v-container>
                </v-tab-item>

                <v-tab-item v-show="jsonState['appointment']">
                  <v-container class="px-6 py-6">
                    <div class="relative mt-4">
                      <v-icon color="primary" size="14" class="mdi mdi-circle mb-1"></v-icon>
                      <span>選擇來源</span>
                    </div>
                    <div class="relative ml-4">
                      <v-select
                        return-object filled dense rounded full-width
                        item-text="source"
                        hide-details="auto"
                        class="setting-input mt-4"
                        label="選擇來源"
                        :items="Object.keys(jsonSource['appointment'][crmUser])"
                        v-model="source"
                        @change="clearDoctorLinks"
                      ></v-select>
                    </div>
                    <div
                      v-show="source === '自定義'"
                      class="relative ml-4"
                    >
                        <v-text-field
                          filled rounded full-width hide-details="auto"
                          :placeholder="'輸入自定義來源'"
                          class="setting-input mt-4"
                          v-model="customizeSource"
                          @input="clearDoctorLinks"
                        />
                    </div>
                    <template v-if="clinicUser">
                      <div class="relative mt-4">
                        <v-icon color="primary" size="14" class="mdi mdi-circle mb-1"></v-icon>
                        <span>預約對象</span>
                      </div>
                      <div class="relative ml-4">
                        <v-radio-group
                          v-model="appointmentTarget"
                          row
                          hide-details="auto"
                          class="mt-3"
                          @change="clearDoctorLinks"
                        >
                          <v-radio label="全院線上預約" value="clinic"></v-radio>
                          <v-radio label="指定醫師" value="doctor"></v-radio>
                        </v-radio-group>

                        <div v-if="appointmentTarget === 'doctor'" class="doctor-select mt-3">
                          <div v-if="doctorsLoading" class="d-flex justify-center pa-6">
                            <v-progress-circular indeterminate color="primary"></v-progress-circular>
                          </div>
                          <v-alert v-else-if="doctorLoadError" type="error" text class="ma-3">
                            醫師清單載入失敗，請稍後再試。
                          </v-alert>
                          <v-alert v-else-if="doctorItems.length === 0" type="info" text class="ma-3">
                            此診所目前沒有可選擇的醫師。
                          </v-alert>
                          <template v-else>
                            <div class="doctor-select__header">
                              <v-checkbox
                                :input-value="allDoctorsSelected"
                                :indeterminate="someDoctorsSelected"
                                label="全選"
                                hide-details
                                class="ma-0 pa-0"
                                @change="toggleAllDoctors"
                              ></v-checkbox>
                              <span class="grey--text text--darken-1 text-caption">
                                已選 {{ selectedDoctorCodes.length }} 位
                              </span>
                            </div>
                            <div class="doctor-select__list">
                              <v-checkbox
                                v-for="doctor in doctorItems"
                                :key="doctor.doctor_code"
                                v-model="selectedDoctorCodes"
                                :label="doctor.doctor_name"
                                :value="doctor.doctor_code"
                                hide-details
                                class="doctor-select__item ma-0"
                                @change="clearDoctorLinks"
                              ></v-checkbox>
                            </div>
                          </template>
                        </div>
                      </div>
                    </template>
                  </v-container>
                </v-tab-item>
              </v-tabs-items>
              <v-container fluid class="d-flex justify-end">
                <!-- <v-btn
                  class="mr-2" color="default"
                  @click="reset()"
                >重選</v-btn> -->

                <v-btn
                  v-if="mode !=='' && source !==''"
                  class="rounded-lg" color="primary"
                  @click="generate()"
                >產生邀請連結</v-btn>
              </v-container>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6">
            <v-card
              v-if="doctorLinks.length"
              flat
              class="doctor-result-panel mx-auto pa-4"
              style="background: #F5F5F5;"
            >
              <div class="doctor-result-header mb-4">
                <div>
                  <div class="font-weight-medium">產生結果</div>
                  <div class="text-caption grey--text text--darken-1 mt-1">
                    共 {{ doctorLinks.length }} 位醫師
                  </div>
                </div>
                <div class="doctor-result-header__actions">
                  <v-btn outlined small color="primary" @click="copyAllDoctorLinks">
                    複製全部網址
                  </v-btn>
                  <v-btn
                    color="primary"
                    small
                    :loading="downloadingAllQrCodes"
                    @click="downloadAllDoctorQrCodes"
                  >
                    下載全部 QRCode
                  </v-btn>
                </div>
              </div>

              <div class="doctor-result-list">
                <v-card
                  v-for="item in doctorLinks"
                  :key="item.doctorCode"
                  outlined
                  class="doctor-result-card"
                >
                  <v-card-title class="doctor-result-card__title">
                    <v-icon color="primary" class="mr-2">mdi-doctor</v-icon>
                    <span>{{ item.doctorName }}</span>
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text class="doctor-result-card__content">
                    <div class="doctor-result-card__qr">
                      <vue-qr
                        :logoSrc="jsonLogo.appointment"
                        :text="item.original"
                        :size="360"
                        :logo-scale="0.225"
                        :ref="`doctorQrCode-${item.doctorCode}`"
                        class="doctor-result-card__qr-image"
                      >
                      </vue-qr>
                      <v-btn
                        outlined
                        small
                        color="primary"
                        class="mt-3"
                        @click="downloadDoctorQr(item)"
                      >
                        下載 QRCode
                      </v-btn>
                    </div>

                    <div class="doctor-result-card__links">
                      <div class="doctor-result-card__link-section">
                        <div class="doctor-result-card__label">短網址</div>
                        <template v-if="item.short">
                          <div class="doctor-result-card__url">{{ item.short }}</div>
                          <v-btn
                            outlined
                            small
                            color="primary"
                            class="mt-2"
                            @click="copyUrl(item.short)"
                          >
                            複製短網址
                          </v-btn>
                        </template>
                        <v-alert v-else type="error" text dense class="mb-0 mt-2">
                          短網址產生失敗，仍可使用下方完整網址與 QRCode。
                        </v-alert>
                      </div>

                      <div class="doctor-result-card__link-section mt-5">
                        <div class="doctor-result-card__label">完整網址</div>
                        <div class="doctor-result-card__url">{{ item.original }}</div>
                        <v-btn
                          outlined
                          small
                          color="primary"
                          class="mt-2"
                          @click="copyUrl(item.original)"
                        >
                          複製完整網址
                        </v-btn>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </div>
            </v-card>

            <v-card
              flat class="mx-auto" style="background: #F5F5F5;"
              v-else-if="jsonSuperLink.original !==undefined"
            >
              <div class="d-flex flex-column justify-center align-center pt-6 pb-0">
                  <vue-qr
                    :logoSrc="logo"
                    :text="jsonSuperLink.original"
                    :size="500"
                    :logo-scale="0.225"
                    ref="qrCode"
                    class="my-10"
                    style="width: 250px; height: 250px;"
                  >
                  </vue-qr>
                <v-btn outlined small color="primary" class="mt-2" @click="download()">
                  下載QRcode
                </v-btn>
              </div>
              <div class="relative my-2 mt-6">
                <v-container fluid>
                  <v-row>
                    <v-col cols="12" sm="3">
                      <div class="relative mt-2 pl-4">
                        <v-icon color="primary" size="14" class="mdi mdi-circle mb-1"></v-icon>
                        <span>完整網址</span>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        v-model="jsonSuperLink.original"
                        readonly filled rounded full-width hide-details="auto"
                        class="setting-input"
                      />
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-btn
                        class="rounded-lg ml-4" color="primary"
                        @click="copyUrl(jsonSuperLink.original)"
                      >複製網址</v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="3">
                      <div class="relative mt-2 pl-4">
                        <v-icon color="primary" size="14" class="mdi mdi-circle mb-1"></v-icon>
                        <span>短網址</span>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        v-model="jsonSuperLink.short"
                        readonly filled rounded full-width hide-details="auto"
                        class="setting-input"
                      />
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-btn
                        class="rounded-lg ml-4" color="primary"
                        @click="copyUrl(jsonSuperLink.short)"
                      >複製網址</v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </div>
            </v-card>

            <v-card
              flat class="mx-auto" style="background: #F5F5F5;"
              v-else
            ></v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-main>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { getDoctorListAPI } from "@/api/misc";
import { createDoctorAppointmentLinksAPI, getSuperLinksAPI } from "@/api/notice";
import Navigation from "../components/Navigation";
import GuideTour from "../components/utils/GuideTour.vue";
import JSZip from "jszip";

export default {
  name: "SuperLink",
  components: {GuideTour, Navigation},
  data() {
    return {
      loading: true,
      tabs: 0,
      mode: '',
      source: '',
      customizeSource: '',
      appointmentTarget: 'clinic',
      doctorItems: [],
      selectedDoctorCodes: [],
      doctorLinks: [],
      doctorsLoading: false,
      doctorLoadError: false,
      downloadingAllQrCodes: false,
      logo: '',
      jsonState: {
        'bind_line': true,
        'add_line': true,
        'add_messenger': true,
        'appointment': true
      },
      jsonLogo: {
        'bind_line': '/images/line.svg',
        'add_line': '/images/line.svg',
        'add_messenger': 'https://i.imgur.com/H3wh8V1.png',
        'appointment': 'https://i.imgur.com/UBpCo78.png'
      },
      jsonMode: {
        '先綁定再加好友': 'bind_line',
        '先加好友再綁定': 'add_line',
      },
      jsonSource: {
        '': {
          '立牌': 'TVmx25bb',
          '官網': 'vZP461HM',
          'Google Map': 'vZP571HV',
          'FB': '3RuFZnoE',
          'IG': 'LgKZARfr',
          'Youtube': 'hDC7gkaB',
          'Tiktok': 'gLlaMkaB',
          '廣告': 'Kl8a61HM',
          '名片': 'Agf2QRfr',
          '好友推薦': 'SVHxJ24C',
          '部落格文章': 'cY1De5Zq',
          '海報': 'DDsQDsIF',
          'NFC立牌': 'mUK1xrvB',
          'NFC卡片': 'AHpex68i',
          'NFC桌貼': 'V7ZMr8ag',
          '簡訊': 'z2XrYtS2',
        },
        '先綁定再加好友': {
          '立牌': 'TVmx25bb',
          '官網': 'vZP461HM',
          'Google Map': 'vZP571HV',
          'FB': '3RuFZnoE',
          'IG': 'LgKZARfr',
          'Youtube': 'hDC7gkaB',
          'Tiktok': 'gLlaMkaB',
          '廣告': 'Kl8a61HM',
          '名片': 'Agf2QRfr',
          '好友推薦': 'SVHxJ24C',
          '部落格文章': 'cY1De5Zq',
          '海報': 'DDsQDsIF',
          'NFC立牌': 'mUK1xrvB',
          'NFC卡片': 'AHpex68i',
          'NFC桌貼': 'V7ZMr8ag',
          '簡訊': 'z2XrYtS2',
        },
        '先加好友再綁定': {
          '立牌': 'TVmx25bb',
          '官網': 'vZP461HM',
          'Google Map': 'vZP571HV',
          'FB': '3RuFZnoE',
          'IG': 'LgKZARfr',
          'Youtube': 'hDC7gkaB',
          'Tiktok': 'gLlaMkaB',
          '廣告': 'Kl8a61HM',
          '名片': 'Agf2QRfr',
          '好友推薦': 'SVHxJ24C',
          '部落格文章': 'cY1De5Zq',
          '海報': 'DDsQDsIF',
          'NFC立牌': 'mUK1xrvB',
          'NFC卡片': 'AHpex68i',
          'NFC桌貼': 'V7ZMr8ag',
          '簡訊': 'z2XrYtS2',
        },
        'add_messenger': {
          '立牌': 'TVmx25bb',
          '官網': 'vZP461HM',
          'Google Map': 'vZP571HV',
          'FB': '3RuFZnoE',
          'IG': 'LgKZARfr',
          'Youtube': 'hDC7gkaB',
          'Tiktok': 'gLlaMkaB',
          '廣告': 'Kl8a61HM',
          '名片': 'Agf2QRfr',
          '好友推薦': 'SVHxJ24C',
          '部落格文章': 'cY1De5Zq',
          '海報': 'DDsQDsIF',
          'NFC立牌': 'mUK1xrvB',
          'NFC卡片': 'AHpex68i',
          'NFC桌貼': 'V7ZMr8ag',
          '簡訊': 'z2XrYtS2',
        },
        'appointment': {
          'doctorUser': {
            '醫師官網': 'DoctorWebsite',
            '醫師部落格': 'DoctorBlog',
            'FB': 'DoctorFB',
            'IG': 'DoctorIG',
            'Youtube': 'DoctorYoutube',
            'Tiktok': 'DoctorTiktok',
            '廣告': 'DoctorAds',
            '名片': 'BusinessCard',
            '自定義': 'Customize',
          },
          'clinicUser': {
            '診所官網': 'ClinicWebsite',
            '診所部落格': 'ClinicBlog',
            'Google Map': 'GoogleMap',
            'FB': 'ClinicFB',
            'IG': 'ClinicIG',
            'Youtube': 'ClinicYoutube',
            'Tiktok': 'ClinicTiktok',
            '廣告': 'ClinicAds',
            '名片': 'BusinessCard',
            '自定義': 'Customize',
          }
        }
      },
      // jsonSuperLink: { "original": "https://liff.line.me/1622774606-my6kd0On?c=3731181091&d=&p=IDCGniPB", "short": "https://link.dentco.tw/62d08368" }
      jsonSuperLink: {}
    }
  },
  computed: {
    ...mapGetters([
      'axiosParamData',
      'liffUser',
      'doctorUser',
      'clinicUser'
    ]),
    crmUser: {
      get() {
        if (this.doctorUser) {
          return 'doctorUser';
        } else {
          return 'clinicUser';
        }
      },
      set(val) {

      }
    },
    allDoctorsSelected() {
      return this.doctorItems.length > 0 && this.selectedDoctorCodes.length === this.doctorItems.length
    },
    someDoctorsSelected() {
      return this.selectedDoctorCodes.length > 0 && !this.allDoctorsSelected
    }
  },
  methods: {
    ...mapActions({

    }),
    async getSuperLinks(source) {
      const mode = (this.jsonMode[this.mode] !== undefined) ? this.jsonMode[this.mode] : this.mode;
      this.loading = true;

      try {
        const res = await getSuperLinksAPI({...this.axiosParamData, patient_code: source})
        const link = res.data.data[mode]

        if (mode === 'bind_line' && link.original) {
          link.original = this.toLineAppUrl(link.original)
        }

        this.logo = this.jsonLogo[mode]
        return link
      } catch (error) {
        this.$notify.error('連結產生失敗，請稍後再試。')
        throw error
      } finally {
        this.loading = false
      }
    },
    async getDoctorAppointmentLinks(source) {
      this.loading = true
      this.doctorLinks = []
      this.jsonSuperLink = {}

      try {
        const res = await createDoctorAppointmentLinksAPI({
          ...this.axiosParamData,
          patient_code: source,
          doctor_codes: this.selectedDoctorCodes
        })
        const links = res.data && res.data.data && res.data.data.appointment_doctors

        if (!Array.isArray(links)) {
          throw new Error('指定醫師連結回傳格式錯誤')
        }

        this.doctorLinks = links.map(item => ({
          doctorCode: item.doctor_code,
          doctorName: item.doctor_name,
          original: item.original,
          short: item.short,
          shorteningSuccess: item.shortening_success
        }))
        this.jsonSuperLink = {}
      } catch (error) {
        this.$notify.error('指定醫師連結產生失敗，請稍後再試。')
        throw error
      } finally {
        this.loading = false
      }
    },
    async generate () {
      let source;

      if (this.mode === 'appointment') {
        if (this.jsonSource[this.mode][this.crmUser][this.source] === 'Customize') {
          source = this.customizeSource;
        } else {
          source = this.jsonSource[this.mode][this.crmUser][this.source];
        }
      } else {
        source = this.jsonSource[this.mode][this.source];
      }

      if (
        this.mode === 'appointment' &&
        this.clinicUser &&
        this.appointmentTarget === 'doctor' &&
        this.selectedDoctorCodes.length === 0
      ) {
        this.$notify.error('請至少勾選一位醫師。')
        return
      }

      if (
        this.mode === 'appointment' &&
        this.clinicUser &&
        this.appointmentTarget === 'doctor' &&
        (!source || source.trim() === '')
      ) {
        this.$notify.error('請輸入自定義來源。')
        return
      }

      try {
        if (this.mode === 'appointment' && this.clinicUser && this.appointmentTarget === 'doctor') {
          await this.getDoctorAppointmentLinks(source)
        } else {
          const link = await this.getSuperLinks(source)
          this.doctorLinks = []
          this.jsonSuperLink = link
        }
      } catch (error) {
        // 錯誤提示由對應的連結產生方法統一處理。
      }
    },
    setMode (mode) {
      if (mode !== '') {
        if (this.jsonMode[mode] !== undefined) {
          this.mode = this.jsonMode[mode];
        } else {
          this.mode = mode;
        }
      } else {
        this.mode = '';
      }

      this.source = '';
      this.doctorLinks = []
    },
    toLineAppUrl(url) {
      return url.replace(/^https:\/\/liff\.line\.me\//, 'line://app/')
    },
    async loadDoctors() {
      this.doctorsLoading = true
      this.doctorLoadError = false

      try {
        const res = await getDoctorListAPI(this.axiosParamData)
        this.doctorItems = res.data
      } catch (error) {
        this.doctorItems = []
        this.doctorLoadError = true
      } finally {
        this.doctorsLoading = false
      }
    },
    toggleAllDoctors(checked) {
      this.selectedDoctorCodes = checked
        ? this.doctorItems.map(doctor => doctor.doctor_code)
        : []
      this.clearDoctorLinks()
    },
    clearDoctorLinks() {
      this.doctorLinks = []
      if (this.mode === 'appointment') {
        this.jsonSuperLink = {}
      }
    },
    copyText(text) {
      const input = document.createElement('textarea');
      input.value = text;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
    },
    copyUrl (url) {
      this.copyText(url)
      this.$notify.success('已複製網址！')
    },
    copyAllDoctorLinks() {
      const links = this.doctorLinks
        .map(item => [
          item.doctorName,
          `完整網址：${item.original}`,
          `短網址：${item.short || '產生失敗'}`
        ].join('\n'))
        .join('\n\n')
      this.copyText(links)
      this.$notify.success('已複製全部網址！')
    },
    downloadImage(source, filename) {
      const a = document.createElement('a')
      a.style.display = 'none'
      a.href = source
      a.download = filename
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    getDoctorQrElement(item) {
      const ref = this.$refs[`doctorQrCode-${item.doctorCode}`]
      const qrComponent = Array.isArray(ref) ? ref[0] : ref
      return qrComponent && qrComponent.$el
    },
    sanitizeFilename(value) {
      return String(value)
        .replace(/[\\/:*?"<>|]/g, '_')
        .trim() || '醫師'
    },
    downloadDoctorQr(item) {
      const qrElem = this.getDoctorQrElement(item)

      if (!qrElem || !qrElem.src) {
        this.$notify.error('QRCode 尚未產生完成，請稍後再試。')
        return
      }

      this.downloadImage(qrElem.src, `doctor-appointment-${item.doctorCode}-qr-code.png`)
    },
    async downloadAllDoctorQrCodes() {
      if (this.downloadingAllQrCodes) {
        return
      }

      this.downloadingAllQrCodes = true

      try {
        await this.$nextTick()
        const zip = new JSZip()

        for (let index = 0; index < this.doctorLinks.length; index++) {
          const item = this.doctorLinks[index]
          const qrElem = this.getDoctorQrElement(item)

          if (!qrElem || !qrElem.src) {
            throw new Error(`QRCode 尚未完成：${item.doctorName}`)
          }

          const response = await fetch(qrElem.src)
          if (!response.ok) {
            throw new Error(`QRCode 讀取失敗：${item.doctorName}`)
          }

          const imageBlob = await response.blob()
          const order = String(index + 1).padStart(2, '0')
          const doctorName = this.sanitizeFilename(item.doctorName)
          const doctorCode = this.sanitizeFilename(item.doctorCode)
          zip.file(`${order}-${doctorName}-${doctorCode}.png`, imageBlob)
        }

        const zipBlob = await zip.generateAsync({type: 'blob'})
        const zipUrl = window.URL.createObjectURL(zipBlob)
        this.downloadImage(zipUrl, '指定醫師預約-QRCode.zip')
        window.setTimeout(() => window.URL.revokeObjectURL(zipUrl), 1000)
        this.$notify.success('已下載全部 QRCode！')
      } catch (error) {
        this.$notify.error('全部 QRCode 下載失敗，請稍後再試。')
      } finally {
        this.downloadingAllQrCodes = false
      }
    },
    download () {
      const qrElem = this.$refs.qrCode.$el;
      this.downloadImage(qrElem.src, 'qr-code.png');

      // html2canvas(qrElem).then(canvas => {
      //   canvas.toBlob(blob => {
      //     download(qrElem.src, 'qr-code.png');
      //   });
      // });
    },
    reset () {
      this.mode = '';
      this.source = '';
    }
  },
  mounted() {
    const vm = this;
    if (this.clinicUser) {
      this.loadDoctors()
    }
    getSuperLinksAPI({...this.axiosParamData, patient_code: ''}).then(res => {
      const data = res.data.data;
      // console.log(data);
      Object.keys(data).forEach(function(mode, index) {
        if (vm.jsonState[mode] !== undefined) {
          if (data[mode]['original'] === null) {
            vm.jsonState[mode] = false;
          }
        }
        vm.loading = false;
      });
    }).finally(() => {
      vm.loading = false
    })
  }
}
</script>

<style lang="scss">
.setting-input {
  .v-input__control .v-input__slot {
    min-height: 36px !important;
    border-radius: 10px;
    padding: 0 18px !important;
  }

  &.v-select .v-input__control .v-input__slot {
    padding: 0 8px 0 18px !important;
  }
}

.doctor-select {
  max-width: 660px;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  overflow: hidden;
}

.doctor-select__header {
  min-height: 48px;
  padding: 10px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  background: #fafafa;
  border-bottom: 1px solid #e0e0e0;
}

.doctor-select__list {
  max-height: 232px;
  overflow-y: auto;
}

.doctor-select__item {
  min-height: 44px;
  padding: 8px 16px;
  border-bottom: 1px solid #f2f2f2;
}

.doctor-select__item:last-child {
  border-bottom: 0;
}

.doctor-result-header {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.doctor-result-panel {
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 190px);
}

.doctor-result-list {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding-right: 4px;
  scrollbar-gutter: stable;
}

.doctor-result-header__actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}

.doctor-result-card + .doctor-result-card {
  margin-top: 16px;
}

.doctor-result-card__title {
  padding: 14px 16px;
  font-size: 16px;
}

.doctor-result-card__content {
  display: flex;
  align-items: flex-start;
  gap: 24px;
  padding: 20px !important;
}

.doctor-result-card__qr {
  flex: 0 0 150px;
  text-align: center;
}

.doctor-result-card__qr-image {
  display: block !important;
  width: 150px;
  height: 150px;
  margin: 0 auto;
  padding: 6px;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  vertical-align: middle;
}

.doctor-result-card__links {
  flex: 1 1 auto;
  min-width: 0;
}

.doctor-result-card__label {
  color: #424242;
  font-size: 14px;
  font-weight: 600;
}

.doctor-result-card__url {
  margin-top: 6px;
  padding: 10px 12px;
  background: #f5f5f5;
  border-radius: 6px;
  color: #424242;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  line-height: 1.5;
  word-break: break-all;
}

@media (max-width: 600px) {
  .doctor-result-panel {
    display: block;
    max-height: none;
  }

  .doctor-result-list {
    overflow-y: visible;
    padding-right: 0;
  }

  .doctor-result-header {
    align-items: stretch;
    flex-direction: column;
  }

  .doctor-result-header__actions {
    display: grid;
    grid-template-columns: 1fr;
  }

  .doctor-result-header__actions .v-btn {
    width: 100%;
  }

  .doctor-result-card__content {
    flex-direction: column;
    align-items: stretch;
    gap: 20px;
    padding: 16px !important;
  }

  .doctor-result-card__qr {
    flex-basis: auto;
  }
}
</style>
